module.exports = __webpack_public_path__ + "media/images/social/twitter-a2e51a2abd68badec8866f15a6089e99.png";